// wallet.js
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('#btnConnectWallet');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    if (typeof window.ethereum === 'undefined') {
      alert('No wallet detected. Please install MetaMask.');
      return;
    }

    try {
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts'
      });
      console.log('Connected account:', accounts[0]);
    } catch (err) {
      console.error('User rejected wallet connection', err);
    }
  });
});
